// INV-9 / SPEC-001 §13: failures render as a VISIBLE, NAMED fault, never a
// blank. Every page-level empty/error condition should render through one of
// these two components rather than silently returning null.
import type { JSX } from 'preact';

export function FaultState({ name, detail }: { name: string; detail?: string }): JSX.Element {
  return (
    <div class="fault-state" role="alert">
      <div>Fault: {name}</div>
      {detail && <div>{detail}</div>}
    </div>
  );
}

export function EmptyState({ label }: { label: string }): JSX.Element {
  return <div class="empty-state">{label}</div>;
}

/** INV-9: `/api/me` succeeding with `mapped: false` must render a clear
 * NAMED "no access" state — never a blank page and never a silent OWNER
 * fallback (see client/src/lib/session.ts). */
export function NoAccessState({ email }: { email?: string | null }): JSX.Element {
  return (
    <div class="no-access-state" role="alert" data-testid="no-access-state">
      <div>No access</div>
      <div>
        {email ? `${email} is` : 'This account is'} not mapped to nvManager. Ask Tomer to add it.
      </div>
    </div>
  );
}
